// import React, { useState } from "react";
// import Select from "react-select";
// import { LocationData } from "./LocationData";
// import { Col, Row } from "react-bootstrap";

// const LocationFilter = ({
//   onChange,
//   GpRequired = true,
//   majraRequired = true,
//   width = 4,
// }) => {
//   const [districtValue, setDistrictValue] = useState(null);
//   const [blockValue, setBlockValue] = useState(null);
//   const [gpValue, setGpValue] = useState(null);
//   const [majraValue, setMajraValue] = useState(null);

//   const districts = Object.keys(LocationData).map((key) => ({
//     label: key,
//     value: key,
//   }));

//   const blocks = districtValue?.value
//     ? Object.keys(LocationData[districtValue.value]).map((key) => ({
//         label: key,
//         value: key,
//       }))
//     : [];

//   const gps =
//     districtValue?.value && blockValue?.value
//       ? Object.keys(LocationData[districtValue.value][blockValue.value]).map(
//           (key) => ({
//             label: key,
//             value: key,
//           })
//         )
//       : [];

//   const majras =
//     districtValue?.value && blockValue?.value && gpValue?.value
//       ? Object.keys(
//           LocationData[districtValue.value][blockValue.value][gpValue.value]
//         ).map((key) => ({
//           label: key,
//           value: key,
//         }))
//       : [];

//   const handleDistrictChange = (value) => {
//     setDistrictValue(value);
//     setBlockValue(null);
//     setGpValue(null);
//     setMajraValue(null);
//     onChange({
//       district: value,
//       block: null,
//       grampanchayat: null,
//       majra: null,
//     });
//   };

//   const handleBlockChange = (value) => {
//     setBlockValue(value);
//     setGpValue(null);
//     setMajraValue(null);
//     onChange({
//       district: districtValue,
//       block: value,
//       grampanchayat: null,
//       majra: null,
//     });
//   };

//   const handleGpChange = (value) => {
//     setGpValue(value);
//     setMajraValue(null);
//     onChange({
//       district: districtValue,
//       block: blockValue,
//       grampanchayat: value,
//       majra: null,
//     });
//   };

//   const handleMajraChange = (value) => {
//     setMajraValue(value);
//     onChange({
//       district: districtValue,
//       block: blockValue,
//       grampanchayat: gpValue,
//       majra: value,
//     });
//   };

//   const customStyles = {
//     control: (provided) => ({
//       ...provided,
//       minHeight: "38px",
//       height: "38px",
//       fontSize: "13px",
//       zIndex: 100,
//     }),
//     menu: (provided) => ({
//       ...provided,
//       zIndex: 3000,
//     }),
//   };

//   return (
//     <Row className=" align-items-center position-relative">
//       <Col sm={width} className="mb-2">
//         <Select
//           options={districts}
//           value={districtValue}
//           onChange={handleDistrictChange}
//           placeholder="Select District"
//           styles={customStyles}
//           isClearable
//         />
//       </Col>
//       <Col sm={width} className="mb-2">
//         <Select
//           options={blocks}
//           value={blockValue}
//           onChange={handleBlockChange}
//           placeholder="Select Block"
//           isDisabled={!districtValue}
//           styles={customStyles}
//           isClearable
//         />
//       </Col>
//       {GpRequired && (
//         <Col sm={width} className="mb-2">
//           <Select
//             options={gps}
//             value={gpValue}
//             onChange={handleGpChange}
//             placeholder="Select Grampanchayat"
//             isDisabled={!blockValue}
//             styles={customStyles}
//             isClearable
//           />
//         </Col>
//       )}
//       {majraRequired && (
//         <Col sm="3" className="mb-2">
//           <Select
//             options={majras}
//             value={majraValue}
//             onChange={handleMajraChange}
//             placeholder="Select Majra"
//             isDisabled={!gpValue}
//             styles={customStyles}
//             isClearable
//           />
//         </Col>
//       )}
//     </Row>
//   );
// };

// export default LocationFilter;

import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Col, Row } from "react-bootstrap";

const LocationFilter = ({
  onChange,
  GpRequired = true,
  majraRequired = true,
  width = 4,
  firstDistrict,
}) => {
  const [locationData, setLocationData] = useState([]);
  const [districtValue, setDistrictValue] = useState(null);
  const [blockValue, setBlockValue] = useState(null);
  const [gpValue, setGpValue] = useState(null);
  const [majraValue, setMajraValue] = useState(null);

  useEffect(() => {
    fetch(
      "https://lc-research-projects.s3.ap-south-1.amazonaws.com/maati/baseline/master_data_mapping.json"
    )
      .then((res) => res.json())
      .then((data) => setLocationData(data))
      .catch((err) => console.error("Error fetching location data:", err));
  }, []);

  useEffect(() => {
    if (firstDistrict && locationData.length > 0) {
      const district = locationData.find(
        (d) =>
          d.value === firstDistrict ||
          d.label === firstDistrict ||
          d.label?.includes(firstDistrict) ||
          firstDistrict?.includes(d.label)
      );
      if (district) {
        const districtOption = { label: district.label, value: district.value };
        setDistrictValue(districtOption);
        setBlockValue(null);
        setGpValue(null);
        setMajraValue(null);
        onChange({
          district: districtOption,
          block: null,
          grampanchayat: null,
          majra: null,
        });
      }
    }
  }, [firstDistrict, locationData]);

  const districts = locationData.map((district) => ({
    label: district.label,
    value: district.value,
  }));

  const blocks = districtValue?.value
    ? locationData
        .find((d) => d.value === districtValue.value)
        ?.blocks.map((b) => ({ label: b.label, value: b.value })) || []
    : [];

  const gps =
    districtValue?.value && blockValue?.value
      ? locationData
          .find((d) => d.value === districtValue.value)
          ?.blocks.find((b) => b.value === blockValue.value)
          ?.GPs.map((gp) => ({ label: gp.label, value: gp.value })) || []
      : [];

  const majras =
    districtValue?.value && blockValue?.value && gpValue?.value
      ? locationData
          .find((d) => d.value === districtValue.value)
          ?.blocks.find((b) => b.value === blockValue.value)
          ?.GPs.find((gp) => gp.value === gpValue.value)
          ?.majras.map((m) => ({ label: m.label, value: m.value })) || []
      : [];

  const handleDistrictChange = (value) => {
    setDistrictValue(value);
    setBlockValue(null);
    setGpValue(null);
    setMajraValue(null);
    onChange({
      district: value,
      block: null,
      grampanchayat: null,
      majra: null,
    });
  };

  const handleBlockChange = (value) => {
    setBlockValue(value);
    setGpValue(null);
    setMajraValue(null);
    onChange({
      district: districtValue,
      block: value,
      grampanchayat: null,
      majra: null,
    });
  };

  const handleGpChange = (value) => {
    setGpValue(value);
    setMajraValue(null);
    onChange({
      district: districtValue,
      block: blockValue,
      grampanchayat: value,
      majra: null,
    });
  };

  const handleMajraChange = (value) => {
    setMajraValue(value);
    onChange({
      district: districtValue,
      block: blockValue,
      grampanchayat: gpValue,
      majra: value,
    });
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "38px",
      height: "38px",
      fontSize: "13px",
      zIndex: 100,
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 3000,
    }),
  };

  return (
    <Row className="align-items-center position-relative">
      <Col sm={width} className="mb-2">
        <Select
          options={districts}
          value={districtValue}
          onChange={handleDistrictChange}
          placeholder="Select District"
          styles={customStyles}
          isClearable
        />
      </Col>
      <Col sm={width} className="mb-2">
        <Select
          options={blocks}
          value={blockValue}
          onChange={handleBlockChange}
          placeholder="Select Block"
          isDisabled={!districtValue}
          styles={customStyles}
          isClearable
        />
      </Col>
      {GpRequired && (
        <Col sm={width} className="mb-2">
          <Select
            options={gps}
            value={gpValue}
            onChange={handleGpChange}
            placeholder="Select Grampanchayat"
            isDisabled={!blockValue}
            styles={customStyles}
            isClearable
          />
        </Col>
      )}
      {majraRequired && (
        <Col sm="3" className="mb-2">
          <Select
            options={majras}
            value={majraValue}
            onChange={handleMajraChange}
            placeholder="Select Majra"
            isDisabled={!gpValue}
            styles={customStyles}
            isClearable
          />
        </Col>
      )}
    </Row>
  );
};

export default LocationFilter;
